module.exports = __webpack_public_path__ + "static/media/April2021Newsletter.e7301dd9.pdf";